var _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAudio = function SvgAudio(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 11.6086V7.43474C1 7.15799 1.10536 6.89258 1.29289 6.69688C1.48043 6.50119 1.73478 6.39126 2 6.39126H4.697C4.89453 6.3913 5.08765 6.3303 5.252 6.21595L9.445 3.29839C9.59574 3.19344 9.77098 3.13321 9.95198 3.12413C10.133 3.11505 10.313 3.15746 10.4726 3.24684C10.6323 3.33621 10.7658 3.46918 10.8586 3.63155C10.9515 3.79391 11.0004 3.97956 11 4.16865V14.8747C11 15.0636 10.9509 15.249 10.8579 15.4111C10.7648 15.5732 10.6314 15.7058 10.4718 15.795C10.3121 15.8841 10.1323 15.9263 9.95148 15.9171C9.77065 15.908 9.5956 15.8478 9.445 15.7429L5.252 12.8264C5.08754 12.7124 4.89443 12.6518 4.697 12.6521H2C1.73478 12.6521 1.48043 12.5422 1.29289 12.3465C1.10536 12.1508 1 11.8854 1 11.6086V11.6086Z",
    stroke: "#F8F8F8",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 4.82605C15.5 4.82605 17 6.39127 17 8.99996C17 11.6087 15.5 13.1739 15.5 13.1739",
    stroke: "#F8F8F8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 1.69562C18.5 1.69562 21 4.30431 21 8.99997C21 13.6956 18.5 16.3043 18.5 16.3043",
    stroke: "#F8F8F8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAudio, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Audio.62077d2a.svg";
export { ForwardRef as ReactComponent };